import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  class: "truncate"
};
const _hoisted_3 = {
  key: 0,
  class: "text-[10px] px-1 rounded bg-red-50 text-red-600"
};
const _hoisted_4 = {
  key: 1,
  class: "text-[10px] px-1 rounded bg-slate-100 text-slate-500"
};
import { Folder, FolderOpened, Check } from '@element-plus/icons-vue';
export default {
  __name: 'FolderTreeSelector',
  props: {
    nodes: {
      type: Array,
      default: () => []
    },
    selectedId: {
      type: [Number, String],
      default: null
    },
    excludeId: {
      type: [Number, String],
      default: null
    },
    depth: {
      type: Number,
      default: 0
    }
  },
  emits: ['select'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    function handleClick(node) {
      if (isUnselectable(node)) return;
      emit('select', node.id);
    }
    function isUnselectable(node) {
      return node.pathOnly || node.id === props.excludeId || isDisabled(node) || node.permissionLevel !== 'MANAGE';
    }
    function isDisabled(node) {
      return node.status === 0 || node.status === 'DISABLED';
    }
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_FolderTreeSelector = _resolveComponent("FolderTreeSelector", true);
      return _openBlock(), _createElementBlock("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.nodes, node => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: node.id
        }, [_createElementVNode("div", {
          class: _normalizeClass(['tree-selector-node py-1.5 px-2 rounded text-sm flex items-center gap-1.5 transition-colors', __props.selectedId === node.id ? 'bg-primary-50 text-primary-700' : 'hover:bg-slate-50 text-slate-700', isUnselectable(node) ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer']),
          style: _normalizeStyle({
            paddingLeft: `${8 + __props.depth * 16}px`
          }),
          onClick: $event => handleClick(node)
        }, [_createVNode(_component_el_icon, {
          size: 14,
          class: "shrink-0"
        }, {
          default: _withCtx(() => [node.children?.length ? (_openBlock(), _createBlock(_unref(FolderOpened), {
            key: 0
          })) : (_openBlock(), _createBlock(_unref(Folder), {
            key: 1
          }))]),
          _: 2
        }, 1024), _createElementVNode("span", _hoisted_2, _toDisplayString(node.name), 1), isDisabled(node) ? (_openBlock(), _createElementBlock("span", _hoisted_3, "禁用")) : node.permissionLevel !== 'MANAGE' ? (_openBlock(), _createElementBlock("span", _hoisted_4, "只读")) : _createCommentVNode("", true), __props.selectedId === node.id ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 2,
          size: 14,
          class: "ml-auto text-primary-500"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Check))]),
          _: 1
        })) : _createCommentVNode("", true)], 14, _hoisted_1), node.children?.length ? (_openBlock(), _createBlock(_component_FolderTreeSelector, {
          key: 0,
          nodes: node.children,
          "selected-id": __props.selectedId,
          "exclude-id": __props.excludeId,
          depth: __props.depth + 1,
          onSelect: _cache[0] || (_cache[0] = $event => _ctx.$emit('select', $event))
        }, null, 8, ["nodes", "selected-id", "exclude-id", "depth"])) : _createCommentVNode("", true)], 64);
      }), 128))]);
    };
  }
};